import React, { useState } from 'react';
import { useStateContext } from '../../../../contexts/ContextProvider';
// import CardMedia from '@mui/material/CardMedia';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import CustomerCommentsImagesCarousel from '../CustomerCommentsCards/CustomerCommentsImagesCarousel';

const CustomerCommentsCarousel = () => {
  const { customerComments, convertUtcToLocal, trimHTML } = useStateContext();
  const [activeIndex, setActiveIndex] = useState(0);

  const onChange = (index) => {
    setActiveIndex(index);
  };

  return (
    <>
      {customerComments && customerComments.length > 0 ? (
        <Carousel
          selectedItem={activeIndex}
          onChange={onChange}
          showThumbs={false}
          showStatus={false}
          infiniteLoop
          useKeyboardArrows
          autoPlay
          interval={35 * 1000}
        >
          {customerComments.map((comment) => (
            <div key={comment.id} style={{ textAlign: 'center', width: '70%', margin: 'auto', marginBottom: '7%' }}>
              {/* CAROUSEL WITH ONLY IMAGE
              {comment.attachments.length > 0 && (
                <div style={{ width: '20%', margin: 'auto' }}>
                  <CustomerCommentsImagesCarousel attachments={comment.attachments} />
                </div>
              )} */}
              {/* CONTENT */}
              <h3><b>{comment.title}</b></h3>
              <p>{convertUtcToLocal(comment.publish_date)}</p>
              <hr />
              {/* COMMENT BODY */}
              <div dangerouslySetInnerHTML={{ __html: trimHTML(comment.body, 450) }} />
            </div>
          ))}
        </Carousel>
      ) : (
        <p>Nessun commento cliente trovato ...</p>
      )}
    </>
  );
};

export default CustomerCommentsCarousel